import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { NotificationService } from '../../shared/notification.service';
import { DatePickerService } from '../services/date.picker.service';
import { DateFilterEvent } from './date-filter.interface';

@Component({
  selector: 'cc-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent implements OnInit {
  @ViewChild('openCalendar') iconCalendar: ElementRef;
  @Input() startDate: string | moment.Moment;
  @Input() endDate: string | moment.Moment;
  @Input() maxDate: string | moment.Moment = undefined;
  @Input() minDate: string | moment.Moment = undefined;
  @Input() datePickerOpened = false;
  @Input() opens: string;

  @Output() change = new EventEmitter<DateFilterEvent>();

  constructor(
    private datePickerService: DatePickerService,
    private store: Store<IState>,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {}

  displayDate(startDate, endDate) {
    return `${moment(startDate).format('L')}
      - ${moment(endDate).format('L')}`;
  }

  openPicker() {
    this.datePickerService.toggleDatePicker({
      open: 'left',
      show: true,
      positionX: this.iconCalendar.nativeElement.offsetLeft,
      positionY: this.iconCalendar.nativeElement.offsetTop
    });
  }

  addDateRangeFilter(dateFrom, dateTo) {
    if (this.minDate === undefined || dateFrom.isSameOrAfter(this.minDate)) {
      this.startDate = dateFrom;
      console.log({
        dateFrom,
        dateTo
      })
      this.endDate = dateTo;
      this.change.emit({
        dateFrom: moment(dateFrom),
        dateTo: moment(dateTo)
      });
    } else {
      this.notificationService.open('REPORT_NOT_IN_BACKWARD_DAYS_RANGE');
    }
  }
}
